<template>
  <div class="slide text-center" :style="rootStyle">
    <div class="content">
      <div v-if="data.eyebrow" class="eyebrow" :style="{ color: colors.accent }">
        {{ data.eyebrow }}
      </div>
      <h1 v-if="data.heading" class="heading" :style="headingStyle">
        <template v-for="(chunk, i) in splitHeading">
          <span v-if="chunk.emphasis" :key="i" class="em" :style="{ color: colors.accent }">{{ chunk.text }}</span>
          <span v-else :key="i">{{ chunk.text }}</span>
        </template>
      </h1>
      <p v-if="data.body" class="body" :style="bodyStyle">{{ data.body }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextCenter',
  props: {
    data: { type: Object, required: true },
    config: { type: Object, default: () => ({}) }
  },
  computed: {
    colors() {
      return this.config.color_scheme || {}
    },
    font() {
      return this.config.font || {}
    },
    rootStyle() {
      return {
        background: this.colors.background || '#0F172A',
        color: this.colors.text || '#F8FAFC',
        fontFamily: this.font.body || 'Inter, system-ui, sans-serif'
      }
    },
    headingStyle() {
      return {
        color: this.colors.text || '#F8FAFC',
        fontFamily: this.font.heading || 'Inter, system-ui, sans-serif'
      }
    },
    bodyStyle() {
      return {
        color: this.colors.text || '#F8FAFC',
        fontFamily: this.font.body || 'Inter, system-ui, sans-serif'
      }
    },
    splitHeading() {
      const heading = this.data.heading || ''
      const emphasis = Array.isArray(this.data.emphasis) ? this.data.emphasis : []
      if (!emphasis.length) return [{ text: heading, emphasis: false }]
      const emphasisLower = emphasis.map((e) => e.toLowerCase())
      const pattern = emphasis
        .map((e) => e.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
        .join('|')
      const re = new RegExp(`(${pattern})`, 'gi')
      return heading
        .split(re)
        .filter((t) => t !== '')
        .map((text) => ({
          text,
          emphasis: emphasisLower.includes(text.toLowerCase())
        }))
    }
  }
}
</script>

<style scoped>
.slide {
  width: 1920px;
  height: 1080px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 120px;
  box-sizing: border-box;
}
.content {
  max-width: 1500px;
  text-align: center;
}
.eyebrow {
  font-size: 28px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  margin-bottom: 40px;
}
.heading {
  font-size: 110px;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.02em;
  margin: 0;
}
.heading .em {
  font-style: italic;
}
.body {
  font-size: 42px;
  font-weight: 400;
  line-height: 1.45;
  margin-top: 56px;
  opacity: 0.85;
}
</style>
